module.exports = __webpack_public_path__ + "img/camper-purchase-checklist.cbf3aa6.svg";